import { SubscriptionResult } from './SubscriptionResult';
import { runInspectionFn } from '../utils/runInspectionFn';
import {checkSubscriptionFn} from "../../AccessChecker/checkSubscriptionFn";

export class SubscriptionResultRecurring extends SubscriptionResult {
    constructor(subscriptionKeysByType, subscriptionKeysByRecurring) {
        super([]);
        this.subscriptionKeysByType = subscriptionKeysByType;
        this.subscriptionKeysByRecurring = subscriptionKeysByRecurring;
    }

    // returns: boolean
    hasSubscriptionTo() {
        const subscriptionByType = runInspectionFn(checkSubscriptionFn, this.subscriptionKeysByType);
        const subscriptionByRecurring =
            this.subscriptionKeysByRecurring.length === 0 ?
                false :
                runInspectionFn(checkSubscriptionFn, this.subscriptionKeysByRecurring);
        return subscriptionByType || subscriptionByRecurring;
    }
}
